import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-balans-passiva',
  templateUrl: './tekst-balans-passiva.component.html',
  styleUrls: ['./tekst-balans-passiva.component.scss',],
})

export class TekstBalansPassivaComponent {
}

